import { render } from "./presentationComponent.vue?vue&type=template&id=15b5b7a9&scoped=true"
import script from "./presentationComponent.vue?vue&type=script&lang=js"
export * from "./presentationComponent.vue?vue&type=script&lang=js"

import "./presentationComponent.vue?vue&type=style&index=0&id=15b5b7a9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b5b7a9"]])

export default __exports__